const apiKey = '4uxocu7eiqwid6';
export default apiKey;
